import * as ea from "@mnjsplatform/data/lib/actions/errorActions";
import WorkListApi from "../api/workDocumentsApi";

export const WORK_LIST_IMAGE_LOADED = "WORK_LIST_IMAGE_LOADED";

export function getWorkListPagesLinks(tabNum) {
    return dispatch => {
        return WorkListApi.getWorkListPagesLinks(tabNum)
            .then(item => {
                dispatch({type: WORK_LIST_IMAGE_LOADED, data: item});
            })
            .catch(error => {
                dispatch(ea.errorRaised(error));
            });
    };
}